import { useGetUsers } from '@entities/user';
import { Loader, Select, type SelectProps } from '@mantine/core';
import { IconChevronDown } from '@tabler/icons-react';
import { PaginateType } from '@shared/types';

export const ManagerSelect = ({ ...props }: SelectProps) => {
  const { data, isLoading } = useGetUsers({
    filter: {
      ['role.name']: 'manager',
    },
    paginate: PaginateType.NONE,
  });

  const dataA = data?.map(item => ({
    label: `${item.profile?.firstName} ${item.profile?.lastName}`,
    value: item.id.toString(),
  }));

  return (
    <Select
      data={dataA}
      rightSection={
        isLoading ? (
          <Loader size='xs' />
        ) : (
          <IconChevronDown size={20} color='var(--mantine-color-primary-7)' />
        )
      }
      searchable
      {...props}
    />
  );
};
